import { Navbar, Nav } from "rsuite";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";
import images from "../../assets/images";
import { Container } from "reactstrap";
import LanguageDropdown from "./LanguageDropdown";
import MobileNavbarMenu from "./MobileNavbar";
import { useLocation, useNavigate } from "react-router-dom";
import { clientAppUrl } from "../../redux/base/types/url";

const NavbarMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [active, setActive] = useState(location.pathname);
  const [showMenu, setShowMenu] = useState(false);
  const t = useSelector(getLocalization);
  const changeNavbarMenu = (eventKey: string) => {
    setActive(eventKey);
  };
  useEffect(() => {
    !location.pathname.includes("profile") && setActive(location.pathname);
  }, [location.pathname]);
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//fw-cdn.com/12610973/5000459.js";
    script.setAttribute("chat", "true");
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <>
      <MobileNavbarMenu
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        active={active}
        onSelect={changeNavbarMenu}
      />
      <header className="w-100 navbar-menu-outer-div d-flex align-items-center justify-content-center w-100 ">
          <Container className=" navbar-container-custom ">
          <Navbar className="navbar-menu ">
            <Nav className="customLogoNav">
              <Navbar.Brand onClick={() => navigate("/")}>
                <img
                  src={images.logoiconcolored}
                  alt={"logo"}
                  width={160}
                  className="navbarLogo"
                />
              </Navbar.Brand>
            </Nav>
            <Nav pullRight className="lg-navbar-menu-custom">
              {/* <LanguageDropdown /> */}
              <Nav.Item
                eventKey="login"
               href={"https://appv2.rentificial.com/" }
              
               target="_blank"
                
              >
                <p
                  className="primaryButton"
                 
                >
                  {t.getString("LOGIN")}
                </p>
              </Nav.Item>
            </Nav>
            <Nav pullRight className="lg-navbar-menu-custom" activeKey={active}>
              <Nav.Item eventKey="/" href={"/"}>
                {t.getString("HOME")}
              </Nav.Item>
              <Nav.Item eventKey="/solutions" href={"/solutions/"}>
                {t.getString("SOLUTIONS")}
              </Nav.Item>
              <Nav.Item eventKey="/features" href={"/features/"}>
                {t.getString("FEATURES")}
              </Nav.Item>
              <Nav.Item eventKey="/pricing" href={"/pricing/"}>
                {t.getString("PRICING")}
              </Nav.Item>
              <Nav.Item eventKey="/contactus" href={"/contactus/"}>
                {t.getString("CONTACT US")}
              </Nav.Item>
              <Nav.Item eventKey="/help" href={"/help/"}>
                {t.getString("HELP")}
              </Nav.Item>
            </Nav>
            <Nav
              className="toggle-navbar-menu-custom"
              pullRight
              onSelect={(eventKey) => setShowMenu(!showMenu)}
            >
              <Nav.Item>
                <i className=" dripicons-align-right font-size-28" />
              </Nav.Item>
            </Nav>
          </Navbar>
        </Container>
      </header>
    </>
  );
};
export default NavbarMenu;
